<template>
  <div class="dialog-batch-config">
    <regular-page
        ref="sendExpertPage"
        :parent-id="parentId"
        config-path="/enrolment/regular/thesisManage/assignedRecord"
      ></regular-page>
  </div>
</template>

<script>
import regularPage from '@/layout/regularPage';
export default {
  name: 'resetPwd',
  components: { regularPage },
  props: {
    query: '',
    parentId: ''
  },
  data () {
    return {};
  },
  created () {},
  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/layout/dialogs/thesisManage/assignedRecord.vue